module.exports = __webpack_public_path__ + "static/media/porto-de-galinhas-pe.981c06b6.jpg";